import request from './request'

export async function login(loginObj) {    //登入
    const resp = await request().post("/login",loginObj);
    return resp.data;
}
// 下载中心 
export async function getListDownloadCenters(data){  //查询下载中心信息
    const resp = await request().get('/admin/downloadCenters/listDownloadCenters?page='+data.page+'&pageSize='+data.pageSize);
    return resp.data;
}
export async function deleteDownloadCenters(id){  //删除下载中心信息
    const resp = await request().delete('/admin/downloadCenters/deleteDownloadCenters?id='+id);
    return resp.data;
}
export async function saveDownloadCenters(data){  //保存下载中心信息
    const resp = await request().post('/admin/downloadCenters/saveDownloadCenters',data,{headers: {'Content-Type': 'application/json'}});
    return resp.data;
}

export async function  updataDownloadCenters(data) {    //修改下载中心信息
    const resp = await request().put('/admin/downloadCenters/updataDownloadCenters',data,{headers: {'Content-Type': 'application/json'}});
    return resp.data;
}
// 企业信息|公司信息
export async function getCompanyInfo(){  //查询公司信息
    const resp = await request().get('/admin/companyInfo/list');
    return resp.data;
}
export async function deleteCompanyInfo(id){  //删除公司信息
    const resp = await request().delete('/admin/companyInfo/deleteCompanyInfo?id='+id);
    return resp.data;
}
export async function saveCompanyInfo(data){  //保存公司信息
    const resp = await request().post('/admin/companyInfo/saveCompanyInfo',data,{headers: {'Content-Type': 'application/json'}});
    return resp.data;
}
export async function  updateCompanyInfo(data) {    //修改公司信息
    const resp = await request().put('/admin/companyInfo/updateCompanyInfo',data,{headers: {'Content-Type': 'application/json'}});
    return resp.data;
}
export async function  changeSort(data) {    //调整企业信息排序
    const resp = await request().put('/admin/companyInfo/changeSort?id='+data.id+'&isUp='+data.isUp);
    return resp.data;
}
// 招聘信息|工作机会
export async function listJoinUs(data){  //查询招聘信息
    const resp = await request().get('/admin/joinUs/listJoinUs?page='+data.page+'&pageSize='+data.pageSize);
    return resp.data;
}
export async function deleteJoinUs(id){  //删除招聘信息
    const resp = await request().delete('/admin/joinUs/deleteJoinUs?id='+id);
    return resp.data;
}
export async function saveJoinUs(data){  //保存招聘信息
    const resp = await request().post('/admin/joinUs/saveJoinUs',data,{headers: {'Content-Type': 'application/json'}});
    return resp.data;
}
export async function  updateJoinUs(data) {    //修改招聘信息
    const resp = await request().put('/admin/joinUs/updateJoinUs',data,{headers: {'Content-Type': 'application/json'}});
    return resp.data;
}
export async function getListEducationals(){  //查询学历
    const resp = await request().get('/admin/educationals/listEducationals');
    return resp.data;
}
// 动态新闻
export async function listNews(data){  //查询动态新闻
    const resp = await request().get('/admin/news/listNews?page='+data.page+'&pageSize='+data.pageSize);
    return resp.data;
}
export async function deleteNews(id){  //删除动态新闻
    const resp = await request().delete('/admin/news/deleteNews?id='+id);
    return resp.data;
}
export async function saveNews(data){  //保存动态新闻
    const resp = await request().post('/admin/news/saveNews',data,{headers: {'Content-Type': 'application/json'}});
    return resp.data;
}
export async function  updateNews(data) {    //修改动态新闻
    const resp = await request().put('/admin/news/updateNews',data,{headers: {'Content-Type': 'application/json'}});
    return resp.data;
}
// 求职者信息
export async function listJobSeeker(data){  //查询求职者信息
    const resp = await request().get('/admin/jobSeeker/listJobSeeker?page='+data.page+'&pageSize='+data.pageSize);
    return resp.data;
}
export async function deleteJobSeeker(id){  //删除求职者信息
    const resp = await request().delete('/admin/jobSeeker/deleteJobSeeker?id='+id);
    return resp.data;
}
export async function getListJoinUs(){  //查询全部招聘信息
    const resp = await request().get('/admin/joinUs/listJoinUs?page=1&pageSize=999');
    return resp.data;
}
export async function getListDocType(){  //证件类型
    const resp = await request().get('/admin/docType/listDocType');
    return resp.data;
}
// 联系我们信息
export async function listContactUs(data){  //查询联系我们信息
    const resp = await request().get('/admin/contactUs/listContactUs?page='+data.page+'&pageSize='+data.pageSize);
    return resp.data;
}
export async function deleteContactUs(id){  //删除联系我们信息
    const resp = await request().delete('/admin/contactUs/deleteContactUs?id='+id);
    return resp.data;
}
// 常见问题
export async function listFaq(data){  //查询常见问题
    const resp = await request().get('/admin/faq/listFaq?page='+data.page+'&pageSize='+data.pageSize);
    return resp.data;
}
export async function deleteFaq(id){  //删除常见问题
    const resp = await request().delete('/admin/faq/deleteFaq?id='+id);
    return resp.data;
}
export async function saveFaq(data){  //保存常见问题
    const resp = await request().post('/admin/faq/saveFaq',data,{headers: {'Content-Type': 'application/json'}});
    return resp.data;
}
export async function  updataFaq(data) {    //修改常见问题
    const resp = await request().put('/admin/faq/updataFaq',data,{headers: {'Content-Type': 'application/json'}});
    return resp.data;
}
// 轮播图
export async function listAllSwiperInfo(data){  //查询轮播图
    const resp = await request().get('/admin/swiperInfo/listAllSwiperInfo?page='+data.page+'&pageSize='+data.pageSize);
    return resp.data;
}
export async function deleteSwiperInfo(id){  //删除轮播图
    const resp = await request().delete('/admin/swiperInfo/deleteSwiperInfo?id='+id);
    return resp.data;
}
export async function saveSwiperInfo(data){  //新增轮播图
    const resp = await request().post('/admin/swiperInfo/saveSwiperInfo',data,{headers: {'Content-Type': 'application/json'}});
    return resp.data;
}
export async function  updateSwiperInfo(data) {    //修改轮播图
    const resp = await request().put('/admin/swiperInfo/updateSwiperInfo',data,{headers: {'Content-Type': 'application/json'}});
    return resp.data;
}
export async function  switchState(data) {    //修改轮播图状态【启用-禁用】
    const resp = await request().put('/admin/swiperInfo/switchState',data);
    return resp.data;
}
// 发展历程
export async function listDevelopmentHistory(data){  //查询发展历程
    const resp = await request().get('/admin/developmentHistory/listDevelopmentHistory?page='+data.page+'&pageSize='+data.pageSize);
    return resp.data;
}
export async function deleteDevelopmentHistory(id){  //删除发展历程
    const resp = await request().delete('/admin/developmentHistory/deleteDevelopmentHistory?id='+id);
    return resp.data;
}
export async function saveDevelopmentHistory(data){  //保存发展历程
    const resp = await request().post('/admin/developmentHistory/saveDevelopmentHistory',data,{headers: {'Content-Type': 'application/json'}});
    return resp.data;
}
export async function  updataDevelopmentHistory(data) {    //修改发展历程
    const resp = await request().put('/admin/developmentHistory/updataDevelopmentHistory',data,{headers: {'Content-Type': 'application/json'}});
    return resp.data;
}